
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>andreagt.com</title>

  <!-- Google Font: Source Sans Pro -->
  <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback">
  <!-- Font Awesome -->
  <link rel="stylesheet" href="/../../../assets/plugins/fontawesome-free/css/all.min.css">
  <!-- Theme style -->
  <link rel="stylesheet" href="/../../../assets/dist/css/adminlte.min.css">


<style>
 .centerdiv {
    margin-left: auto;
    margin-right: auto;
    display: block;
    text-align: center;
    background-color: black;
    
}.IconoWhatsApp{
  height: 0px;
}img.whatsapp {
  position: fixed;
  width: 40px;
  bottom: 65px;
  right: 42px;
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  z-index: 50;

}

</style>

 


</head>
<body class="hold-transition login-page">
  <div class="text-center">
    <img class="profile-user-img img-fluid img-circle"
         src="./assets/dist/img/logo_andrea.png"  style="opacity: .9"
         alt="User profile picture">
  </div>

  <div class="login-box">
    <div class="login-logo" >
    
        <!-- <a href="#/inicio" ><b >www.andreagt.com</b></a> -->

        <div class="col-sm-6">
          <h1 style="color: rgb(80, 80, 80);">www.andreagt.com</h1>
        </div>
   
    </div>
    <!-- /.login-logo -->
    <div class="card">
      <div class="card-body login-card-body">
        <p class="login-box-msg"></p>
  
        <form [formGroup]="formLoginCliente">
          <p style="font-size:20px;color: rgb(21, 21, 21);">Escribe tu número de teléfono.</p>

          <div class="input-group mb-4">
            <input type="password" class="form-control"  style="font-size: 25px;width: 20px; height: 48px;border-style: solid;color:black" mask='0000-0000' formControlName="txtClave" inputmode="numeric"  (keyup.enter)="onSubmit()">
            <div class="input-group-append">
           
             
                  <span class="input-group-text" (click)="OnMostrarPassword()"><i class="fas fa-phone"></i></span>
             
        
            </div>
          </div>
          
          <div class="row">
            
            <div class="text-center" >

              <div *ngIf="mostrarPassword == true">

                <p style="font-size:20px;color: rgb(21, 21, 21);">{{numeroMovil}}</p>
              </div>
              
              <div *ngIf="noExisteMovil == true">
                  <label for="label1" style="font-size: 18px;"><code>Por favor utiliza CREAR CUENTA NUEVA.</code></label>
                </div>
                <div *ngIf="noExisteUsuario == true">
                  <label for="label1" style="font-size: 18px;"><code>No existe registro de Usuario.</code></label>
                </div>
            </div>
          



            <!-- /.col -->
            <div class="col-6" >
          
                <button type="button" class="btn btn-primary btn-block" (click)="onSubmit()" style="font-size: 20px;font-weight:bold; height: 48px;color: #ffffff;background-color: #0058db;">Continuar</button>
    
           
            </div>
            <!-- /.col -->





          </div>
        </form>
  
        <div class="social-auth-links text-center mb-3">
          <p>- O -</p>
          <a href="#registro-cliente/1" class="btn btn-block" style="height: 55px;font-weight:bold;font-size: 20px;color: #ffffff;background-color: #0058db;">
            Crear  Cuenta Nueva
          </a>
          <a  class="btn btn-block btn-danger" style="font-size: 20px;height: 48px;font-weight:bold;background-color:#d40606;" (click)="OnIrInicio()"> 
             Ir a Inicio
          </a>
        </div>
        <!-- /.social-auth-links -->
  
        <div class="IconoWhatsApp">
          <a
          href="https://wa.me/+50243185405?text=mensaje"
          target="_blank">
          <img id="appear"
            class="whatsapp"
            src="./assets/dist/img/whatsapp.png"
            alt="IconoWhatsApp"
          />
        </a>
      </div>


        <p class="mb-1">
        
        </p>
        <p class="mb-0">
         
        </p>
      </div>
      <!-- /.login-card-body -->
    </div>

    


  </div>
  <!-- /.login-box -->
  
  <!-- jQuery -->
 
  

  
</body>
</html>
